import { RefObject, useEffect, useRef } from "react";
import useEvent from "react-use-event-hook";

interface IFilterOutsideClick {
  handleClose: () => void;
}

export const useClickOutside = <T extends HTMLElement = HTMLElement>({
  handleClose,
}: IFilterOutsideClick): { clickRef: RefObject<T> } => {
  const clickRef = useRef<T>(null);

  const handleClickOutside = useEvent((event: MouseEvent) => {
    const target = event.target as Node;

    // Do nothing if the target is not connected element with document
    if (!target?.isConnected) {
      return;
    }

    if (clickRef.current && !clickRef.current.contains(target)) {
      handleClose();
    }
  });

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  });

  return {
    clickRef,
  };
};
